
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ApiDocumentation = () => {
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <iframe
        src="/docs/api-doc.html"
        title="API Docs"
        width="100%"
        height="100%"
        style={{ border: 'none', flex: 1 }}
      />
      <Footer />
    </div>
  );
};

export default ApiDocumentation;